import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './sitemap.component.scss';
var SitemapComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SitemapComponent, _super);
    function SitemapComponent(element) {
        return _super.call(this, element) || this;
    }
    SitemapComponent.prototype.init = function () {
    };
    SitemapComponent.prototype.bindEvents = function () {
    };
    return SitemapComponent;
}(Base));
export { SitemapComponent };



//////////////////
// WEBPACK FOOTER
// ./components/sitemap/sitemap.component.ts
// module id = 511
// module chunks = 0